const footerColumns = [
  {
    title: "站内分区",
    links: [
      { label: "热度榜单", href: "#rank" },
      { label: "快讯流", href: "#feed" },
      { label: "深挖材料", href: "#materials" },
    ],
  },
  {
    title: "快捷入口",
    links: [
      { label: "入口导航", href: "#entries" },
      { label: "跟进爆料", href: "#follow" },
      { label: "返回顶部", href: "#top" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-5xl px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr] lg:gap-16">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50">
                料
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">黑料bu</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-loose text-foreground-600">
              黑料bu爆料直达站，聚合最新事件线索、深挖材料与入口导航，帮你第一时间跟上爆料后续。
            </p>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="text-xs font-semibold tracking-[0.2em] text-foreground-400">{column.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {column.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-300 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 黑料bu · 内容仅作线索聚合与浏览参考，请自行核实。
          </p>
          <p className="text-xs text-foreground-400">本站为静态展示页，不含任何真实提交与账号功能。</p>
        </div>
      </div>
    </footer>
  );
}